const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const RECORDING_SID_RE = /^RE[0-9a-f]{32}$/i;

export type CallRecordingRef = {
  sid: string;
  duration?: number | null;
  status?: string | null;
  callSid?: string | null;
};

export function isCallId(value: string) {
  return UUID_RE.test(value);
}

export function isRecordingSid(value: string) {
  return RECORDING_SID_RE.test(value);
}

export function recordingSidFromEntry(entry: {
  sid?: string | null;
  mediaUrl?: string | null;
  uri?: string | null;
  url?: string | null;
}) {
  if (entry?.sid && isRecordingSid(entry.sid)) {
    return entry.sid;
  }

  const candidate = entry?.mediaUrl || entry?.uri || entry?.url || '';
  const match = String(candidate).match(/Recordings\/(RE[0-9a-f]{32})/i);
  return match?.[1] || null;
}

export function recordingsFromCallPayload(payload: {
  recordings?: Array<{
    sid?: string | null;
    mediaUrl?: string | null;
    uri?: string | null;
    url?: string | null;
    duration?: number | string | null;
    status?: string | null;
    callSid?: string | null;
  }> | null;
  CallSid?: string | null;
  callSid?: string | null;
  sid?: string | null;
}): CallRecordingRef[] {
  const callSid = payload?.CallSid || payload?.callSid || payload?.sid || null;
  const seen = new Set<string>();
  const out: CallRecordingRef[] = [];

  for (const entry of payload?.recordings || []) {
    const sid = recordingSidFromEntry(entry);
    if (!sid || seen.has(sid)) continue;
    seen.add(sid);
    const duration =
      entry.duration === null || entry.duration === undefined
        ? null
        : Number(entry.duration);
    out.push({
      sid,
      duration: Number.isFinite(duration as number)
        ? (duration as number)
        : null,
      status: entry.status || null,
      callSid: entry.callSid || callSid,
    });
  }

  return out;
}
